<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Logs de SMTP de alertas</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button type="button" @click="consultar" class="btn-info"><i class="fa fa-search"></i><span>Consultar</span></button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Formulario de consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select @change="changeTipoFecha" name="tipo_fecha" v-model="form.tipo_fecha" id="tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="tipo_fecha">Tipo de fecha</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4" v-show="form.tipo_fecha === 'P'">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker
                                name="desde"
                                v-model="form.desde"
                                type="date"
                                format="dd-MM-yyyy"
                                id="desde"
                                lang="es"
                                ></date-picker>
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4" v-show="form.tipo_fecha === 'P'">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker
                                name="hasta"
                                v-model="form.hasta"
                                type="date"
                                format="dd-MM-yyyy"
                                id="hasta"
                                lang="es"
                                ></date-picker>
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card__title">
                <h5>Resultados de la consulta</h5>
            </div>
            <div class="card__content">
                <k-table ref="logsAlertas" 
                    :searchEnabled="false"
                    @ver="ver"
                    :createButton="false" 
                    :filterStatus="false" 
                    :editButton="false" 
                    :deleteButton="false" 
                    @seleccionar="seleccionar" 
                    :path="path" 
                    :params="form"
                    :buttons="[
                        {
                            text : '',
                            class : 'btn-info',
                            icon : 'fa-eye',
                            event : 'ver'
                        }
                    ]"
                    :columns="[
                    {
                        display : 'Fecha',
                        value : 'fecha'
                    },
                    {
                        display : 'Mensaje de error',
                        value : 'mensaje_error'
                    },
                    {
                        display : 'Factura',
                        value : 'factura.numero'
                    }
                ]"></k-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                desde: '',
                hasta: '',
                tipo_fecha: 'H'
            },
            path: url + '/logs-smtp-alertas'
        };
    },
    methods: {
        ver: function (documento) {
            window.open(url + '/comprobantes?id_comprobante=' + documento.factura_id, '_blank');
        },
        consultar: function () {
            this.$refs.logsAlertas.loadRows();
        },
        changeTipoFecha: function () {
            if (this.form.tipo_fecha === 'P') {
                let desde = new Date();
                desde.setDate(desde.getDate() - 30);
                this.form.hasta = moment(new Date()).format('YYYY-MM-DD');
                this.form.desde = moment(desde).format('YYYY-MM-DD');
            }
            this.consultar();
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/LogsSmtpAlertas.vue